<template>
  <el-button ref="rcButton" v-bind="$attrs" :class="$attrs.prop" v-on="$listeners">
    <template v-for="slot in slots">
      <!-- 默认插槽 -->
      <slot v-if="isDefaultSlot(componentSlot(slot))" :name="slot">
        <template v-if="text">
          {{ text }}
        </template>
      </slot>

      <slot v-else :name="slot"></slot>
    </template>
  </el-button>
</template>

<script>
import { slotMixins } from "../mixins/slotMixins";
export default {
  name: "RcButton",
  mixins: [slotMixins],
  props: {
    text: [String, Number, Boolean],
    slots: {
      type: Array,
      default: () => ["default"]
    }
  }
};
</script>

<style lang="scss" scoped>
.router {
  cursor: pointer;
  &:hover {
    color: $scim-color-primary;
  }
}
.delete {
  cursor: pointer;
  color: $scim-color-error;
}
</style>
